import { PageHit } from '@app-types/page.types'
import { NewsSearchHit, PageSearchHit } from '@app-domains/meilisearch/types/content-search.types'

export function mapPageSearchHitToPageHit(hit: PageSearchHit): PageHit {
    return {
        id: 0,
        title: hit.title ?? '',
        slug: hit.slug,
        locale: hit.locale,
        type: 'page',
        objectID: hit.slug,
        createdAt: '',
        updatedAt: '',
        publishedAt: '',
        positionedPages: '',
        header: [],
        elements: [],
        seo: {
            id: 0,
            metaTitle: hit.metaTitle ?? hit.title ?? '',
            metaDescription: hit.metaDescription ?? '',
            keywords: null,
            metaRobots: null,
            structuredData: null,
            metaViewport: null,
            canonicalURL: null,
            metaImage: { id: 0, name: '', alternativeText: null, caption: null, width: 0, height: 0, formats: {} as any, hash: '', ext: '', mime: '', size: 0, url: 'http://placehold.it/300x300', previewUrl: null, provider: '', provider_metadata: null, folderPath: '', createdAt: '', updatedAt: '', folder: null },
            metaSocial: [],
        },
        createdBy: {} as any,
        updatedBy: {} as any,
        localizations: [],
    }
}

export function mapNewsSearchHitToPageHit(hit: NewsSearchHit): PageHit {
    const base = mapPageSearchHitToPageHit(hit)
    return {
        ...base,
        type: 'news-item',
        seo: {
            ...base.seo,
            metaDescription: hit.description ?? hit.metaDescription ?? base.seo.metaDescription,
        },
    }
}
